import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import styles from "@/styles/ContentHeader.module.scss";
import classnames from "classnames";

var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};

IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ContentHeader(_ref) {
  var _classnames;

  var text = _ref.text,
      link = _ref.link,
      viewTypeClassName = _ref.viewTypeClassName,
      main = _ref.main;
  var classNames = classnames(styles.header, (_classnames = {}, _defineProperty(_classnames, styles.grid, viewTypeClassName === "grid"), _defineProperty(_classnames, styles.list, viewTypeClassName === "list"), _defineProperty(_classnames, styles.channelList, viewTypeClassName === "channelList"), _defineProperty(_classnames, styles.pickuplist, viewTypeClassName === "pickuplist"), _defineProperty(_classnames, styles.genrePalette, viewTypeClassName === "genrePalette"), _classnames));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [main && /*#__PURE__*/_jsx("h1", {
      className: classNames,
      children: /*#__PURE__*/_jsx(Content, {
        text: text,
        link: link
      })
    }), !main && /*#__PURE__*/_jsx("h2", {
      className: classNames,
      children: /*#__PURE__*/_jsx(Content, {
        text: text,
        link: link
      })
    })]
  });
}

function Content(_ref2) {
  var text = _ref2.text,
      link = _ref2.link;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [link && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VersatileLink, {
        href: link.href,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.title,
          children: text
        })
      }), /*#__PURE__*/_jsx(VersatileLink, {
        href: link.href,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.more,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.caret,
            children: ["\u3082\u3063\u3068\u898B\u308B", /*#__PURE__*/_jsx(IconArrow, {})]
          })
        })
      })]
    }), !link && /*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: text
    })]
  });
}